import { ACCENT, VIOLET, TEAL, OK } from '../../lib/uiTokens';
import { fmtKc } from '../../lib/formatters';

/**
 * „Kam jde koruna tržeb" — jeden stohovaný pruh podílů na tržbách místo
 * vodopádu. Vodopád říkal totéž, co tabulka vedle (tržby → marže → EBITDA),
 * jen graficky; podíl na tržbách je naopak to jediné, co z tabulky přečíst
 * nejde, a vejde se do 60 px místo 240.
 *
 * Jede z payloadu `struktura` (dřív `donut`, který endpoint posílal a frontend
 * ho nikdy nepřečetl).
 */
const BARVA = {
    prime:    ACCENT,
    personal: VIOLET,
    energie:  TEAL,
    ostatni:  'var(--text-tertiary)',
    ebitda:   OK,
};

export default function StrukturaPruh({ segmenty, cardStyle }) {
    if (!segmenty?.length) return null;
    // Bez tržeb jsou všechny podíly nula — prázdný pruh a legenda pěti nul
    // neřeknou nic, tak se karta nekreslí.
    if (!segmenty.some(s => Math.abs(s.pct ?? 0) > 0.05)) return null;
    // Záporná EBITDA by pruh rozbila (negativní šířka) — kreslí se jen kladné
    // podíly a záporná se přizná v legendě číslem.
    const kladne = segmenty.filter(s => (s.pct ?? 0) > 0);
    const soucet = kladne.reduce((a, s) => a + s.pct, 0) || 1;

    return (
        <div className="rounded-2xl px-4 py-3.5" style={cardStyle}>
            <div className="text-[9.5px] font-bold uppercase mb-2.5"
                style={{ letterSpacing: '0.12em', color: 'var(--text-secondary)' }}>
                Kam jde koruna tržeb
            </div>
            <div className="flex rounded-md overflow-hidden" style={{ height: 16, gap: 1 }}>
                {kladne.map(s => (
                    <div key={s.kod} title={`${s.nazev} ${s.pct} % · ${fmtKc(s.kc)}`}
                        style={{ width: `${(s.pct / soucet) * 100}%`, background: BARVA[s.kod] || 'var(--text-tertiary)' }} />
                ))}
            </div>
            <div className="flex flex-wrap mt-2.5" style={{ gap: '4px 12px' }}>
                {segmenty.map(s => (
                    <span key={s.kod} className="inline-flex items-center gap-1.5 text-[10.5px]"
                        style={{ color: 'var(--text-secondary)' }} title={fmtKc(s.kc)}>
                        <span style={{ width: 7, height: 7, borderRadius: 2, background: BARVA[s.kod] || 'var(--text-tertiary)' }} />
                        {s.nazev} {String(s.pct).replace('.', ',')} %
                    </span>
                ))}
            </div>
        </div>
    );
}
